// extracted by mini-css-extract-plugin
export default {"button":"Logout_button__7L3KE"};